import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Navigate } from '@tanstack/react-router';
import { sessionApi, sessionChanged, sessionQuery } from '../api/session';
import { Centered } from '../components/Layout';
import { he } from '../i18n/he';
import { Button, Card, Loading, SIGNED_OUT } from '@avrahami/ui';

/** Signed in, but not platform staff (for example a store owner after their invitation). */
export function NoAccessPage() {
  const queryClient = useQueryClient();
  const session = useQuery(sessionQuery);
  const logout = useMutation({
    mutationFn: sessionApi.logout,
    onSettled: () => {
      sessionChanged(queryClient, SIGNED_OUT);
    },
  });
  if (session.isPending) {
    return (
      <Centered>
        <Loading />
      </Centered>
    );
  }
  if (session.data?.kind !== 'signed-in') return <Navigate to="/login" search={{}} />;
  if (session.data.me.platform !== null) return <Navigate to="/tenants" />;
  return (
    <Centered>
      <Card title={he.noAccess.title}>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-slate-700">{he.noAccess.body}</p>
          <Button
            tone="secondary"
            busy={logout.isPending}
            onClick={() => {
              logout.mutate();
            }}
          >
            {he.nav.logout}
          </Button>
        </div>
      </Card>
    </Centered>
  );
}
